/**
 * Shared cart totals — uses Shopify line prices; gifts count only when app discount is applied. */
(function () {
  'use strict';

  function isGiftLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props._gift === 'true';
  }

  function formatMoney(cents) {
    if (typeof window.mmFormatMoneyHtml === 'function') {
      return window.mmFormatMoneyHtml(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return (cents / 1000).toFixed(3);
  }

  function isGiftDiscounted(item) {
    if (!item) return false;
    var qty = item.quantity || 1;
    var finalLine = item.final_line_price != null
      ? item.final_line_price
      : (item.price || 0) * qty;
    if (finalLine <= 0) return true;
    var originalLine = item.original_line_price != null
      ? item.original_line_price
      : (item.price || 0) * qty;
    var disc = 0;
    (item.line_level_discount_allocations || []).forEach(function (alloc) {
      disc += alloc.amount || 0;
    });
    return originalLine > 0 && disc >= originalLine;
  }

  function compute(cart) {
    if (!cart) return { before: 0, after: 0, savings: 0, giftValue: 0 };

    var itemsOriginal = 0;
    var itemsFinal = 0;
    var giftValue = 0;

    (cart.items || []).forEach(function (item) {
      var final = item.final_line_price != null
        ? item.final_line_price
        : (item.price || 0) * (item.quantity || 1);
      var original = item.original_line_price != null ? item.original_line_price : final;

      if (isGiftLine(item)) {
        itemsFinal += final;
        itemsOriginal += original > final ? original : final;
        if (isGiftDiscounted(item)) {
          giftValue += original > 0 ? original : final;
        }
        return;
      }

      itemsFinal += final;
      itemsOriginal += original > final ? original : final;
    });

    var after = itemsFinal;
    var before = itemsOriginal;
    var savings = Math.max(0, before - after);

    return { before: before, after: after, savings: savings, giftValue: giftValue };
  }

  function apply(cart, opts) {
    opts = opts || {};
    var totals = compute(cart);
    var beforeEl = document.querySelector(opts.subtotalEl || '[data-mm-cart-subtotal-val]');
    var savingsRow = document.querySelector(opts.savingsRow || '[data-mm-cart-savings-row]');
    var savingsEl = document.querySelector(opts.savingsEl || '[data-mm-cart-savings-val]');
    var totalEl = document.querySelector(opts.totalEl || '[data-mm-cart-total-val]');

    if (beforeEl) beforeEl.innerHTML = formatMoney(totals.before);
    if (totalEl) totalEl.innerHTML = formatMoney(totals.after);

    if (savingsRow && savingsEl) {
      if (totals.savings > 0) {
        savingsRow.hidden = false;
        savingsEl.innerHTML = formatMoney(totals.savings);
      } else {
        savingsRow.hidden = true;
        savingsEl.innerHTML = '';
      }
    }

    return totals;
  }

  function canIncreaseGiftQty(item, nextQty) {
    if (!item || !isGiftLine(item)) return true;
    return nextQty <= (item.quantity || 1);
  }

  window.MMCartTotals = {
    isGiftLine: isGiftLine,
    compute: compute,
    apply: apply,
    formatMoney: formatMoney,
    canIncreaseGiftQty: canIncreaseGiftQty
  };
})();
